<div class="container">
  <mat-card>
    <form [formGroup]="amazonS3ConfigurationForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.S3 Bucket Name' | translate }}</mat-label>
            <input matInput required formControlName="s3_bucket_name" />
            @if (amazonS3ConfigurationForm.controls.s3_bucket_name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.S3 Bucket Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.S3 Access Key' | translate }}</mat-label>
            <input matInput required type="{{ accessKeyInputType }}" formControlName="s3_access_key" />
            @if (amazonS3ConfigurationForm.controls.s3_access_key.value) {
              <button
                mat-button
                matSuffix
                mat-icon-button
                (mousedown)="accessKeyInputType = 'text'"
                (mouseup)="accessKeyInputType = 'password'"
              >
                @if (accessKeyInputType === 'password') {
                  <fa-icon icon="eye"></fa-icon>
                }
                @if (accessKeyInputType === 'text') {
                  <fa-icon icon="eye-slash"></fa-icon>
                }
              </button>
            }
            @if (amazonS3ConfigurationForm.controls.s3_access_key.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.S3 Access Key' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.S3 Secret Key' | translate }}</mat-label>
            <input matInput required type="{{ secretKeyInputType }}" formControlName="s3_secret_key" />
            @if (amazonS3ConfigurationForm.controls.s3_secret_key.value) {
              <button
                mat-button
                matSuffix
                mat-icon-button
                (mousedown)="secretKeyInputType = 'text'"
                (mouseup)="secretKeyInputType = 'password'"
              >
                @if (secretKeyInputType === 'password') {
                  <fa-icon icon="eye"></fa-icon>
                }
                @if (secretKeyInputType === 'text') {
                  <fa-icon icon="eye-slash"></fa-icon>
                }
              </button>
            }
            @if (amazonS3ConfigurationForm.controls.s3_secret_key.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.S3 Secret Key' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!amazonS3ConfigurationForm.valid || amazonS3ConfigurationForm.pristine"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
